<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main ai_main video_main">
        <SubTitleComponent v-if="global.type == 'client'" :title="title"></SubTitleComponent>
        <div class="box">
          <el-row :gutter="10" v-if="global.type == 'manage'">
            <el-col :span="3">
              <h4>选择客户</h4>
            </el-col>
            <el-col :span="12">
              <el-select v-model="customerValue" placeholder="请选择" @change="customerChange">
                <el-option
                  v-for="item in customerData"
                  :key="item.number"
                  :label="item.number + item.client_name"
                  :value="item.client_name">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <!-- <el-divider content-position="left">选择图片</el-divider> -->
          <!-- <el-radio-group v-model="aiType" @input="AiTypeChange"> -->
          <el-radio-group v-model="aiType" @input="AiTypeChange">
            <div class="ai_type_box">
              <el-radio-button :label="'单图生成'"></el-radio-button>
              <el-radio-button :label="'首尾帧生成'"></el-radio-button>
            </div>
          </el-radio-group>
          <div class="img_bg">
            <el-row :gutter="10">
              <el-col :span="6">
                <div class="upload_box" v-if="aiType == '单图生成'">
                  <el-upload
                    class="upload-demo"
                    action=""
                    :show-file-list="false"
                    multiple
                    :http-request="uploadImage">
                    <div class="img_box" v-if="uploadImg">
                      <img :src="uploadImg" class="">
                    </div>
                    <el-button v-else class="" icon="el-icon-plus"></el-button>
                  </el-upload>
                  <div class="btn upload" v-if="uploadImg">
                    <el-upload
                      class="upload-demo"
                      action=""
                      :show-file-list="false"
                      multiple
                      :http-request="uploadImage">
                      <i class="el-icon-upload2"></i>
                    </el-upload>
                  </div>
                  <div class="btn delete" @click="deleteUpload(0)" v-if="uploadImg"><i class="el-icon-delete"></i></div>
                </div>
                <div class="" v-if="aiType == '首尾帧生成'">
                  <div :class="['upload_box upload_box2',shouWeiCur == 0 ? 'on' : '']">
                    <el-upload
                      class="upload-demo"
                      action=""
                      :show-file-list="false"
                      multiple
                      :http-request="uploadImage1">
                      <div class="img_box" v-if="uploadImgF">
                        <img :src="uploadImgF" class="">
                      </div>
                      <el-button v-else class="" icon="el-icon-plus">首帧</el-button>
                    </el-upload>
                    <div class="btn upload" v-if="uploadImgF">
                      <el-upload
                        class="upload-demo"
                        action=""
                        :show-file-list="false"
                        multiple
                        :http-request="uploadImage1">
                        <i class="el-icon-upload2"></i>
                      </el-upload>
                    </div>
                    <div class="btn delete" @click="deleteUpload(1)" v-if="uploadImgF"><i class="el-icon-delete"></i></div>
                  </div>
                  <div :class="['upload_box upload_box2',shouWeiCur == 1 ? 'on' : '']">
                    <el-upload
                      class="upload-demo"
                      action=""
                      :show-file-list="false"
                      multiple
                      :http-request="uploadImage2">
                      <div class="img_box" v-if="uploadImgE">
                        <img :src="uploadImgE" class="">
                      </div>
                      <el-button v-else class="" icon="el-icon-plus">尾帧</el-button>
                    </el-upload>
                    <div class="btn upload" v-if="uploadImgE">
                      <el-upload
                        class="upload-demo"
                        action=""
                        :show-file-list="false"
                        multiple
                        :http-request="uploadImage2">
                        <i class="el-icon-upload2"></i>
                      </el-upload>
                    </div>
                    <div class="btn delete" @click="deleteUpload(2)" v-if="uploadImgE"><i class="el-icon-delete"></i></div>
                  </div>
                </div>
              </el-col>
              <el-col :span="18">
                <div class="slide_box" v-infinite-scroll="getSlide" infinite-scroll-distance="100">
                  <waterfall class="slide_main" :col="5" :gutterWidth="20" :data="slideData" :lazyDistance="200" :loadDistance="100" @loadmore="getSlide">
                    <template>
                      <div v-for="(item, index) in slideData" :key="'meterial'+index" class="item">
                        <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="" @click="toDetail(index)">
                        <div class="radio" @click="slideClick(index)">
                          <el-radio v-model="slideCur" :label="index">{{ item.space_type + String(index+1) }}</el-radio>
                        </div>
                      </div>
                    </template>
                  </waterfall>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-divider content-position="left">运镜方式</el-divider>
          <el-radio-group v-model="cameraCur">
            <div class="camera_box">
              <div class="item" v-for="(item,index) in cameraData" :key="'camera'+index">
                <img :src="item.img" alt="">
                <el-radio :label="index">{{ item.name }}</el-radio>
              </div>
            </div>
          </el-radio-group>
          <el-divider content-position="left">补充描述</el-divider>
          <div class="">
            <div class="ai_para_box">
              <div class="cue_word">
                <div class="item">
                  <el-input
                    type="textarea"
                    :rows="5"
                    placeholder="请输入内容"
                    v-model="zh_content"
                    resize="none">
                  </el-input>
                </div>
              </div>
            </div>
          </div>
          <el-divider content-position="left">AI大模型</el-divider>
          <div class="">
            <el-radio-group v-model="aiCur" @input="aiChange">
              <div class="ai_box">
                <el-radio v-for="(item,index) in aiData" :key="'ai'+index" :label="item.model_id">{{ item.model_name + '(' + item.price + ')' }}</el-radio>
              </div>
            </el-radio-group>
          </div>
          <el-divider content-position="left">视频时长</el-divider>
          <el-radio-group v-model="durationCur">
            <div class="duration_box">
              <el-radio v-for="(item,index) in durationData" :key="'duration'+index" :label="index">{{ item + 's' }}</el-radio>
            </div>
          </el-radio-group>
          <div class="btn_save">
            <el-button type="success" @click="onSubmit" style="width:100%;">立即生成</el-button>
            <div class="prompt">（本月剩余使用额度 {{ global.money }}元）</div>
          </div>
          <div class="effect_box" v-if="resultStatus != 0">
            <div class="complete" v-if="resultStatus == 2">
              <div class="cur">
                <video :src="effectData[0].file_url" alt="" :poster="posterImg" :controls="isPlaying" ref="videoPlayer" @pause="onVideoPause" @ended="onVideoEnded"></video>
                <div v-if="isPlaying == false" class="play" @click="toPlay"></div>
              </div>
              <div class="tools">
                <div class="btn"><el-button type="success" :icon="favoriteType == true ? 'el-icon-star-off' : 'el-icon-star-on'" @click="toFavorite">{{ favoriteType == true ? '收藏' : '取消收藏' }}</el-button></div>
                <div class=""><el-button type="success" icon="el-icon-download" @click="toDownload">下载</el-button></div>
              </div>
            </div>
            <div class="progress" v-if="resultStatus == 1">
              <el-progress :percentage="percent"></el-progress>
            </div>
          </div>
        </div>
        <el-dialog
          :visible.sync="dialogVisit"
          top="15vh"
          :show-close="false"
          :center="true">
          <div class="img" v-if="dialogCur != -1">
            <img :src="detailImg" alt="">
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>

import { getUser } from '../../utils/api'
import { apiDownload } from '@/utils/download';

let _ajaxType = 0

export default {
  name: 'AiEdit',
  components: {},
  data() {
    return {
      title: '',
      id: 0,
      aiType: '单图生成',
      customerData: [],
      customerValue: '',
      slideData: [],
      slideCur: -1,
      shouWeiCur: 0,
      chooseEffect: '',
      chooseEffectSpace: '',
      uploadImg: '',
      uploadImgF: '',
      uploadImgE: '',
      cameraData: [{
        img: require('../../assets/pic_ai_video_1.gif'),
        name: '慢速推进'
      },{
        img: require('../../assets/pic_ai_video_2.gif'),
        name: '快速推进'
      },{
        img: require('../../assets/pic_ai_video_3.gif'),
        name: '慢速拉远'
      },{
        img: require('../../assets/pic_ai_video_4.gif'),
        name: '快速拉远'
      },{
        img: require('../../assets/pic_ai_video_5.gif'),
        name: '环绕旋转'
      }],
      cameraCur: 0,
      timeCur: 0,
      durationData: [4,8],
      durationCur: 0,
      aiData: [],
      aiDataS: [],
      aiCur: '',
      zh_content: '',
      en_content: '',
      effectId: "0",
      effectData: [],
      effectDataCur: 0,
      posterImg: '',
      resultStatus: 0,
      percent: 0,
      page: 0,
      pagesize: 100,
      allpage: 0,
      materialItemHeight: 100,
      dialogVisit: false,
      dialogCur: -1,
      isPlaying: false,
      favoriteType: true,
      favoriteId: '',
      detailImg: ''
    }
  },
  mounted() {
    let _title = '图生视频'
    if(localStorage.getItem('effect_url')){
      this.chooseEffect = localStorage.getItem('effect_url')
      this.chooseEffectSpace = localStorage.getItem('effect_space')
      localStorage.removeItem('effect_url')
      localStorage.removeItem('effect_space')
      console.log('load', this.chooseEffect, this.chooseEffectSpace)
    }
    if(this.global.type == 'client'){
      _title = this.global.clientName
      // this.getSlide()
    }
    this.title = _title
    if(this.global.type == 'manage'){
      this.getCustomer()
    }
    this.getAI()
  },
  methods: {
    handleDetal(index, row) {
      console.log(index, row);
    },
    getData() {
      // 
    },
    getSlide() {
      if(_ajaxType == 1) return
      let _page = this.page + 1
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
        console.log('nowCustomer', nowCustomer)
        let _id = 0
        if(this.global.type == 'client'){
          _id = this.global.clientId
        }
        if(this.global.type == 'manage'){
          _id = nowCustomer.client_id
        }
        let _url = "/api/?mod=effect&action=result_list"
        let _exclude = this.chooseEffect
        let _space_data = {
          page: _page,
          pagesize: this.pagesize,
          client_id: _id,
          exclude: _exclude
        }
        this.axios.post(_url, _space_data).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("effectData", _data);
          if (json.data.errcode == 0) {
            let _slide = []
            if(_data.page == 1){
              if(this.chooseEffect != ''){
                _slide.push({
                  effect_result_id: -1,
                  photo_url: this.chooseEffect,
                  space_type: this.chooseEffectSpace
                })
              }
              this.materialItemHeight = 0
            }
            let _slideArray = [..._slide, ...this.slideData]
            console.log('slideArray', _slideArray)
            this.page = _data.page
            this.allpage = _data.allpage
            this.slideData = [..._slideArray, ..._data.result]
            console.log('slideData', this.slideData)
          }
          console.log(json.data);
        })
      }
    },
    customerChange(e) {
      console.log('customerChange', e)
      let nowCustomer = this.customerData.find(c => c.client_name === e);
      this.global.clientId = nowCustomer.client_id
      this.global.clientName = nowCustomer.client_name
      this.page = 0
      this.allpage = 0
      this.slideData = []
      this.getSlide()
    },
    getCustomer() {
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("customerData", _data);
        if (json.data.errcode == 0) {
          let _client = _data.result[0].client_name
          if(this.global.type == 'manage' && this.global.clientName != ''){
            _client = this.global.clientName
          }
          this.customerValue = _client
          this.customerData = _data.result
          this.getSlide()
        }
        console.log(json.data);
      })
    },
    getAI() {
      let _url = "/api/?mod=ai_model"
      let _aiData = {
        type: 3
      }
      this.axios.post(_url, _aiData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("aiData", _data);
        if (json.data.errcode == 0) {
          this.aiCur = _data.result[0].model_id
          this.aiData = _data.result
          this.aiDataS = _data.result
          this.durationData = _data.result[0].config.duration
        }
        console.log(json.data);
      })
    },
    getHeight() {
      let _materialItem = this.$refs.materialItem[0]
      console.log('height', _materialItem.offsetHeight)
      let _row = this.slideData.length > 5 ? 2 : 1
      this.materialItemHeight = _materialItem.offsetHeight * _row + 15
    },
    spaceChange(e) {
      // console.log(e)
      this.getWorkblank()
    },
    onSubmit() {
      let _this = this
      console.log('submit!');
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=effect&action=video"
      let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
      console.log('nowCustomer', nowCustomer)
      let _id = 0
      if(this.global.type == 'client'){
        _id = this.global.clientId
      }
      if(this.global.type == 'manage'){
        _id = nowCustomer.client_id
      }
      let _prompt = this.zh_content
      let nowAi = this.aiData.find(c => c.model_id === this.aiCur);
      // if(_prompt == ''){
      //   _ajaxType = 0
      //   this.$message.error('请输入中文描述！');
      //   return
      // }
      let _photo = ''
      let _space = ''
      if(this.slideCur != -1){
        _photo = this.slideData[this.slideCur].photo_url
        _space = this.slideData[this.slideCur].space_type
      }
      if(this.aiType == '单图生成' && this.slideCur == -1){
        if(this.uploadImg == ''){
          this.$message.error('请上传或选择图片！');
          return
        }
        _photo = this.uploadImg
        _space = ''
      }
      let _saveData = {
        client_id: _id,
        photo_url: _photo,
        space_type: _space,
        model_id: this.aiCur,
        camera_type: this.cameraData[this.cameraCur].name,
        duration: parseInt(this.durationData[this.durationCur]),
        description: _prompt
      }
      if(this.aiType == '首尾帧生成'){
        _saveData['photo_url'] = this.uploadImgF
        _saveData['end_photo_url'] = this.uploadImgE
      }
      this.posterImg = _saveData['photo_url']
      console.log('nowAi.language', nowAi.language)
      if(nowAi.language == 'en' && _prompt != ''){
        _saveData['description'] = this.zh_content
        this.toTranslate(_saveData)
        return
      }
      console.log(_saveData)
      this.axios.post(_url, _saveData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("saveData", _data);
        if (json.data.errcode == 0) {
          this.effectId = _data.effect_id
          this.resultStatus = 1
          this.getEffect()
          // getUser().then(res => {
          //   console.log('user', res)
          //   if(res.errcode == 0){
          //     _this.global.money = res.data.user.money
          //   }
          // })
          this.axios.post('/api/?mod=user').then(json => {
            if(json.data.errcode == 0){
              _this.global.money = json.data.data.user.money
            }
          })
          this.$message({
            message: '提交成功，正在生成中',
            type: 'success',
            offset: 300,
            duration: 1000,
            onClose: function() {
              let scrollBox = document.querySelector('.main')
              scrollBox.scrollTo({
                top: 10000,
                behavior: 'smooth' // 平滑滚动
              });
            }
          });
        }
        console.log(json.data);
      })
    },
    getEffect() {
      let _id = this.effectId
      let _url = "/api/?mod=effect&action=result"
      let _effectData = {
        effect_id: _id
      }
      this.axios.post(_url, _effectData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("effectData", _data);
        if (json.data.errcode == 0) {
          let _percent = this.percent
          if(_percent < 95){
            _percent = _percent + 5
          }
          if(_percent >= 95){
            _percent = 99
          }
          this.percent = _percent
          if(_data.status == 0){
            setTimeout(this.getEffect, 5000)
            return
          }
          if(_data.status == 1){
            _ajaxType = 0
            this.resultStatus = 2
            this.effectData = _data.result
            setTimeout(()=>{
              // console.log('effect complete',this.$refs.videoPlayer[0])
              let scrollBox = document.querySelector('.main')
              scrollBox.scrollTo({
                top: 10000,
                behavior: 'smooth' // 平滑滚动
              });
              this.percent = 0
            },300)
          }
        }
        // console.log(json.data);
      })
    },
    handleChange(value) {
      console.log(value)
      console.log(this.form)
    },
    toDetail(cur) {
      this.detailImg = this.slideData[cur].photo_url
      this.dialogCur = cur
      this.dialogVisit = true
    },
    slideClick(cur) {
      this.slideCur = cur
      let _photo = this.slideData[cur].photo_url
      if(this.aiType == '单图生成'){
        this.uploadImg = _photo
      }
      if(this.aiType == '首尾帧生成'){
        console.log('shouWeiCur', this.shouWeiCur)
        if(this.shouWeiCur == 1) {
          this.uploadImgE = _photo
        }
        if(this.shouWeiCur == 0) {
          this.uploadImgF = _photo
          setTimeout(() => {
            this.shouWeiCur = 1
          }, 200)
        }
      }
    },
    materialClick(cur) {
      this.materialCur = cur
    },
    uploadImage(image) {
      console.log("1", image);
      if(_ajaxType == 1) return
      _ajaxType = 1
      return new Promise((resolve, reject) => {
        const isImage = image.file.type.startsWith('image/');
        if (!isImage) {
          this.uploadError = '只能上传图片文件';
          _ajaxType = 0
          reject(new Error('只能上传图片文件'));
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          console.log('upload',e)
          const base64Data = e.target.result;
          this.toUpload(0, base64Data);
          resolve(false); // 阻止默认上传行为
        };
        reader.onerror = (error) => {
          console.error('读取文件失败:', error);
          this.uploadError = '读取文件失败，请重试';
          reject(error);
        };
        reader.readAsDataURL(image.file);
      });
    },
    uploadImage1(image) {
      console.log("1", image);
      if(_ajaxType == 1) return
      _ajaxType = 1
      return new Promise((resolve, reject) => {
        const isImage = image.file.type.startsWith('image/');
        if (!isImage) {
          this.uploadError = '只能上传图片文件';
          _ajaxType = 0
          reject(new Error('只能上传图片文件'));
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          console.log('upload',e)
          const base64Data = e.target.result;
          this.toUpload(1, base64Data);
          resolve(false); // 阻止默认上传行为
        };
        reader.onerror = (error) => {
          console.error('读取文件失败:', error);
          this.uploadError = '读取文件失败，请重试';
          reject(error);
        };
        reader.readAsDataURL(image.file);
      });
    },
    uploadImage2(image) {
      console.log("1", image);
      if(_ajaxType == 1) return
      _ajaxType = 1
      return new Promise((resolve, reject) => {
        const isImage = image.file.type.startsWith('image/');
        if (!isImage) {
          this.uploadError = '只能上传图片文件';
          _ajaxType = 0
          reject(new Error('只能上传图片文件'));
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          console.log('upload',e)
          const base64Data = e.target.result;
          this.toUpload(2, base64Data);
          resolve(false); // 阻止默认上传行为
        };
        reader.onerror = (error) => {
          console.error('读取文件失败:', error);
          this.uploadError = '读取文件失败，请重试';
          reject(error);
        };
        reader.readAsDataURL(image.file);
      });
    },
    toUpload(type, base64Data) {
      let _url = "/api/?mod=upload"
      let _uploadData = {
        photo: base64Data
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        _ajaxType = 0
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          if(type == 0){
            this.uploadImg = _data.photo_url
          }
          if(type == 1){
            this.uploadImgF = _data.photo_url
            this.shouWeiCur = 1
          }
          if(type == 2){
            this.uploadImgE = _data.photo_url
            this.shouWeiCur = 1
          }
          this.slideCur = -1
          this.$message({
            message: '上传成功',
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
        }
        console.log(json.data);
      })
    },
    deleteUpload(cur) {
      if(cur == 0){
        this.uploadImg = ''
      }
      if(cur == 1){
        this.uploadImgF = ''
        this.shouWeiCur = 0
      }
      if(cur == 2){
        this.uploadImgE = ''
        this.shouWeiCur = 1
      }
      this.slideCur = -1
    },
    toTranslate(saveData) {
      let _url = "/api/?mod=translate"
      let _zh = this.zh_content
      let _uploadData = {
        description: _zh
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          saveData['description'] = _data.description_en
          let _url = "/api/?mod=effect&action=video"
          this.axios.post(_url, saveData).then(json => {
            // 获取
            let _data = json.data.data
            console.log("saveData", _data);
            if (json.data.errcode == 0) {
              this.effectId = _data.effect_id
              this.resultStatus = 1
              this.getEffect()
              // getUser().then(res => {
              //   console.log('user', res)
              //   if(res.errcode == 0){
              //     this.global.money = res.data.user.money
              //   }
              // })
              this.axios.post('/api/?mod=user').then(json => {
                if(json.data.errcode == 0){
                  _this.global.money = json.data.data.user.money
                }
              })
              this.$message({
                message: '提交成功，正在生成中',
                type: 'success',
                offset: 300,
                duration: 1000,
                onClose: function() {
                  let scrollBox = document.querySelector('.main')
                  scrollBox.scrollTo({
                    top: 10000,
                    behavior: 'smooth' // 平滑滚动
                  });
                }
              });
            }
            console.log(json.data);
          })
        }
        console.log(json.data);
      })
    },
    toDownload(){
      const link = document.createElement('a')
      let _type = this.effectData[0].file_type // 替换为你的图片 URL
      let _href = ''
      console.log('download1',this.effectData)
      if(_type == 0){
        let _img = this.effectData[0].file_url
        if (_img.startsWith('https://oss.ylw.s136.ailo.vip')) {
          _href = _img.replace('https://oss.ylw.s136.ailo.vip', '/ai_images');
        }
        if (_img.startsWith('https://aigc.oss.ylwai.cn')) {
          _href = _img.replace('https://aigc.oss.ylwai.cn', '/ai2_images');
        }
      }
      if(_type == 1){
        let _video = this.effectData[0].file_url
        if (_video.startsWith('https://oss.ylw.s136.ailo.vip')) {
          _href = _video.replace('https://oss.ylw.s136.ailo.vip', '/ai_videos');
        }
        if (_video.startsWith('https://aigc.oss.ylwai.cn')) {
          _href = _video.replace('https://aigc.oss.ylwai.cn', '/ai2_videos');
        }
      }
      console.log('href',_href)
      apiDownload(
        _href
      )
    },
    toFavorite() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=effect_favorite&action=add"
      let _type = this.favoriteType
      let _id = this.effectData[this.effectDataCur].effect_result_id
      let _favoriteData = {
        effect_result_id: _id
      }
      if(_type == false){
        _url = "/api/?mod=effect_favorite&action=cancel"
        _id = this.favoriteId
        _favoriteData = {
          effect_favorite_id: _id
        }
      }
      console.log(_favoriteData)
      this.axios.post(_url, _favoriteData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("favoriteData", _data);
        if (json.data.errcode == 0) {
          this.favoriteType = !_type
          let _content = '取消成功'
          if(!_type == false){
            _content = '收藏成功'
            this.favoriteId = _data.effect_favorite_id
          }
          this.$message({
            message: _content,
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
        }
        console.log(json.data);
      })
    },
    toPlay() {
      const video = this.$refs.videoPlayer;
      if (video.paused) {
        video.play();
        this.isPlaying = true;
      }
    },
    onVideoPause() {
      this.isPlaying = false;
      console.log('视频已暂停');
    },
    onVideoEnded() {
      this.isPlaying = false;
      console.log('视频播放完成');
    },
    aiChange(val) {
      console.log('aiChange', val)
      let nowAi = this.aiData.find(c => c.model_id === val)
      this.durationData = nowAi.config.duration
    },
    AiTypeChange(e) {
      if(e == '首尾帧生成'){
        console.log('首尾帧生成', this.aiDataS)
        let _ai = this.aiDataS.filter(c => c.config.imagecount == '2')
        this.aiData = _ai
      }
      if(e == '单图生成'){
        this.aiData = this.aiDataS
      }
      console.log('AiTypeChange', this.aiData)
      this.aiCur = this.aiData[0].model_id
      this.durationData = this.aiData[0].config.duration
      this.durationCur = 0
    },
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    .ai_type_box {
      margin: 20px 0;
    }
    h4 {
      background: #fff;
      color: rgb(16, 16, 16);
      font-size: 20px;
      font-weight: 400;
      line-height: 2em;
    }
    .el-input__inner {
      width: auto;
    }
    .form {
      margin-top: 20px;
    }
    .camera_box {
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: repeat(5, 1fr);
      gap: 10px;
      .item {
        width: 100%;
        img {
          width: 100%;
          aspect-ratio: 640 / 384; /* 宽高比为 1:1 */
          object-fit: cover;
          border-radius: 8px;
        }
        label {
          display: block;
          margin-top: 10px;
          text-align: center;
        }
      }
    }
    .duration_box,
    .ai_box {
      font-size: 0;
      .el-radio {
        margin: 0 15px 10px 0;
      }
    }
    .ai_para_box {
      margin-top: 20px;
      .cue_word {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 10px;
        margin-bottom: 10px;
      }
      .item {
        position: relative;
        .translate {
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      .slider {
        // 
      }
    }
    .upload-demo {
      width: 100%;
      .el-button {
        width: 100%;
        aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
      }
      img {
        width: 100%;
        aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
        object-fit: cover;
      }
    }
    .upload_box {
      position: relative;
      height: 350px;
      .upload-demo {
        height: 100%;
        button {
          height: 100%;
          aspect-ratio: unset;
        }
      }
      .upload-demo2 {
        height: 50%;
      }
      .img_box {
        position: relative;
        height: 100%;
        img {
          position: absolute;
          top: 50%;
          left: 0;
          max-height: 60%;
          margin-top: -30%;
          aspect-ratio: auto;
        }
      }
      .btn {
        position: absolute;
        bottom: 10px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        &.delete {
          right: 0;
        }
        &.upload {
          right: 50px;
        }
      }
    }
    .upload_box2 {
      height: 170px;
      margin-bottom: 10px;
      border: #999 dashed 1px;
      &.on {
        border-color: #50b85c;
      }
      // .upload-demo {
      //   width: 50%;
      // }
      .img_box {
        img {
          top: 15px;
          margin-top: 0;
        }
      }
      .btn {
        bottom: 5px;
      }
    }
    .slide_box {
      // display: grid;
      // grid-template-columns: repeat(5, 1fr);
      // padding-inline-start: 0;
      // gap: 20px;
      min-height: 100px;
      max-height: 344px;
      overflow: auto;
      // margin-top: 10px;
      .slide_main {
        column-count: 5; /* 设置列数 */
        column-gap: 20px; /* 设置列间距 */
        .item {
          position: relative;
          break-inside: avoid-column; /* 防止内容在列中断开 */
          margin-bottom: 20px; /* 底部间距 */
          // flex: 0 0 calc(30%);
          background: #fff;
          box-sizing: border-box;
          font-size: 0;
          img {
            width: 100%;
            // aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
            // object-fit: cover;
          }
          .radio {
            margin-top: 8px;
            padding-right: 10%;
            box-sizing: border-box;
            font-size: 0;
            text-align: center;
          }
        }
      }
    }
    .material_type {
      margin-top: 30px;
    }
    .material_box {
      display: grid;
      grid-template-columns: repeat(10, 1fr);
      padding-inline-start: 0;
      gap: 10px;
      .item {
        position: relative;
        background: #fff;
        box-sizing: border-box;
        img {
          width: 100%;
          aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          object-fit: cover;
        }
        .radio {
          margin-top: 8px;
          padding-right: 10%;
          box-sizing: border-box;
          font-size: 0;
          text-align: center;
        }
      }
    }
    .btn_save {
      width: 30vw;
      margin-top: 30px;
      .prompt {
        margin-top: 10px;
        width: 100%;
        color: #999;
        text-align: center;
      }
    }
    .effect_box {
      margin-top: 30px;
      .complete {
        .cur {
          position: relative;
          height: 400px;
          text-align: center;
          img,
          video {
            position: relative;
            height: 100%;
            z-index: 1000;
          }
          .play {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(../../assets/ico_play.png) no-repeat;
            background-position: center center;
            background-size: 200px;
            z-index: 1001;
          }
        }
        .list {
          margin-top: 10px;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          padding-inline-start: 0;
          gap: 10px;
          .item {
            padding: 10px;
            background: #fff;
            border: 1px dashed rgb(187, 187, 187);
            border-radius: 5px;
            box-sizing: border-box;
            img {
              width: 100%;
              aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
              object-fit: cover;
            }
            .name {
              font-size: 18px;
              text-align: center;
              line-height: 30px;
            }
          }
        }
        .tools {
          margin-top: 10px;
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          padding-inline-start: 0;
          gap: 10px;
          .btn {
            grid-column: 3;
          }
          .el-button {
            width: 100%;
          }
        }
      }
      .progress {
        padding: 150px 0;
      }
    }
  }
}
.el-dialog {
  .img {
    font-size: 0;
    text-align: center;
    img {
      max-width: 80vw;
      max-height: 70vh;
      object-fit: contain;
    }
  }
}
.el-divider--horizontal {
  margin: 30px 0;
}
.el-divider__text {
  font-size: 20px;
  font-weight: 900;
}
.vue-waterfall-column {
  display: contents !important;
}
</style>


// WEBPACK FOOTER //
// src/views/Effect/Video.vue